// eslint-disable-next-line import/no-cycle
import {
  selectionBasedIDLogicalOperators,
  stringLogicalOperators,
} from '@/composables/segmentations/logicalOperators';

/**
 * Get the current manufacturer properties segments for navigation context
 * These segments are evaluated against the current page's manufacturer context
 */
export const getCurrentManufacturerPropertiesSegments = (includeContext = false) => [
  {
    id: 'id',
    label: 'segmentations.navigation.currentManufacturer.id',
    logical_operators: selectionBasedIDLogicalOperators('id'),
    ...(includeContext && { context: 'navigation.currentManufacturer.id' }),
  },
  {
    id: 'name',
    label: 'segmentations.navigation.currentManufacturer.name',
    logical_operators: stringLogicalOperators('name'),
    ...(includeContext && { context: 'navigation.currentManufacturer.name' }),
  },
];

export default getCurrentManufacturerPropertiesSegments;
